import { ProfileItem, SearchListApi } from 'api/search/search.types'
import { SearchPromoTypes } from 'components/page/Search/Search.types'
import {
  injectPromosToListChunk,
  mapFaceCoordsToItems,
} from 'components/page/Search/searchPromoFunctions'
import { MainSearchState } from 'reducers/search/MainSearchState'
import { SearchListProfileState } from 'reducers/search/SearchListProfileState'

export const injectSearchResult = (
  items: ProfileItem[],
  result: SearchListApi,
  state: MainSearchState
) => {
  if (items.length > 0) {
    return {
      ...result,
      items: insertChunkItems(
        state.searchResult.items,
        mapFaceCoordsToItems(items, result.faceCoordinates)
      ),
      serverItemsCount: state.searchResult.serverItemsCount + items.length,
      isEnd: false,
    }
  }

  return {
    ...state.searchResult,
    isEnd: true,
  }
}

export const injectSearchResultProfile = <P extends { type: SearchPromoTypes }>(
  items: ProfileItem[],
  result: SearchListApi,
  state: SearchListProfileState,
  promosList: P[]
) => {
  if (items.length > 0) {
    const isFirstChunk = state.items.length === 0

    const { searchItems, lastPromoInsert } = injectPromosToListChunk(
      mapFaceCoordsToItems(items, result.faceCoordinates),
      promosList,
      isFirstChunk,
      state.items
    )

    return {
      ...result,
      items: insertChunkItems(state.items, searchItems),
      lastPromoInsert,
    }
  }
}

const insertChunkItems = <T>(stateItems: T[], searchItems: T[]) => {
  return [...stateItems, ...searchItems]
}
